import { decodeURIComponent } from "@lib/utils";
import { MobileFileManager } from "features/createApplication/components/DisplayApplicationIDContent";
import { FileUploadComponent } from "features/createApplication/components/FileUploadComponent";
import { useParams } from "react-router-dom";

export const UploadDocumentPage = () => {
  const { applicationId } = useParams<{ applicationId: string }>();
  const decodedApplicationId = decodeURIComponent(applicationId!).toString();

  return (
    <div>
      <strong className="block mb-2 p-3text-md bg-[#bbd0ce] p-2 pl-4 rounded-sm w-full">
        Upload Documents
      </strong>
      <FileUploadComponent id={decodedApplicationId} />
      {decodedApplicationId && (
        <div className="mb-2 mt-5">
          <strong className="block mt-0 mb-2 text-md bg-[#bbd0ce] p-2 pl-4 rounded-sm">
            Uploaded files
          </strong>
          <MobileFileManager applicationId={decodedApplicationId!} />
        </div>
      )}
    </div>
  );
};
